/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeActiveGoal} from '../api'

export const useMutationRemoveActiveGoal = createReactQueryMutationHook('removeActiveGoal', removeActiveGoal)
